import { BaseTraderWithdrawModel, WithdrawStatusTitles } from '@/features/withdraws'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { getShortenId } from '@/shared/utils/getShortenId'
import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export const withdrawsAssinedColumns: ColumnDef<BaseTraderWithdrawModel>[] = [
  {
    accessorKey: 'id',
    header: () => <div>ID заявки</div>,
    cell: ({ row }) => {
      const id = row.getValue<string>('id')
      return (
        <CopyBlock text={id} title={id}>
          <Link to={`/payout/${id}`} className="text-primary">
            {getShortenId(id)}
          </Link>
        </CopyBlock>
      )
    },
  },
  {
    accessorKey: 'date',
    header: 'Дата и время',
    cell: ({ row }) => {
      return (
        <span className="font-medium text-sm whitespace-nowrap">
          {formatDate(row.original.assignedToTraderAt, 'dateShortAndTimeWithoutSec')}
        </span>
      )
    },
  },
  {
    accessorKey: 'amount',
    header: 'Сумма',
    cell: ({ row }) => {
      return (
        <CopyBlock text={row.original.amountTo.toFixed(2)}>
          {formatCurrency(row.original.amountTo, row.original.currencyTo)}
        </CopyBlock>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.withdrawStatus
      const title = WithdrawStatusTitles[status]
      return <span className="font-medium text-sm">{title}</span>
    },
  },
]
